import PatientFormContainer from './PatientFormContainer';

export default PatientFormContainer;
